/**
 * App.jsx - フライト管理アプリケーション
 * ルーティング & 認証ガード
 */

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import AuthShell from './components/auth/AuthShell';
import Login from './pages/Login';
import Register from './pages/Register';
import AcceptInvite from './pages/AcceptInvite';
import FlightCalendar from './pages/FlightCalendar';
import DipsAircrafts from './pages/DipsAircrafts';
import DipsRedirect from './pages/DipsRedirect';


/**
 * 認証ガード: ログインしていない場合は /login にリダイレクト
 */
function ProtectedRoute({ children }) {
  const { isLoggedIn, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="w-12 h-12 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

/**
 * ログイン済みの場合は / にリダイレクト
 */
function PublicRoute({ children }) {
  const { isLoggedIn, loading } = useAuth();

  if (loading) return null;

  if (isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* 認証画面群 (背景レイヤーを AuthShell で共有、子ルートでカード内容のみ切替) */}
      <Route element={<AuthShell />}>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route path="/register" element={<Register />} />
        <Route path="/invite/:token" element={<AcceptInvite />} />
      </Route>
      {/* DIPS OAuth リダイレクト */}
      <Route path="/redirect" element={<DipsRedirect />} />
      {/* 認証必須エリア */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<FlightCalendar />} />
        <Route path="/dips" element={<DipsAircrafts />} />
      </Route>

      {/* 404 → フライトカレンダーへ */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
